exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".text-carousel-container{display:flex;width:425px;height:450px;flex-direction:column;justify-content:center;align-items:flex-start;position:relative}@media(max-width: 575px){.text-carousel-container{width:100%}}.text-carousel-container .text-group{position:absolute;z-index:1;opacity:1;transition:opacity .5s ease 0s;transform:translateZ(0);text-align:left}.text-carousel-container .text-group.hide{z-index:0;opacity:0}.text-carousel-container .text-group h1,.text-carousel-container .text-group h2,.text-carousel-container .text-group p{margin-bottom:10px;padding:0;color:#fff}.text-carousel-container .text-group p{padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/HeroImage/HeroTextCarousel.scss
// module id = 7694
// module chunks = 13